import { navigate } from "@reach/router";
import axios from "./api";

const headers =
  typeof window !== "undefined"
    ? {
        Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      }
    : {};
// Active listing
export const activeListing = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}companyDirectory/activeListings`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// Media delete
export const MediaDelete = async (id, callback) => {
  try {
    const response = await axios({
      method: "delete",
      headers,
      url: `${process.env.GATSBY_API_URL}projects/deleteMedia/${id}`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// company listing
export const companyListing = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}dashboard/companyListing`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// project auction

export const projectAuction = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}projects/projectAuctions`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// add User
export const addUser = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}companyDirectory/addUser`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// check user

export const checkUser = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}checkUser`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// link user

export const linkUser = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}companyDirectory/linkUser`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getBusinessUnit = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}projects/businessUnits`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

// add business unit

export const addBusinessUnit = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}project/addProject`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// update business unit

export const updateBusinessUnit = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}project/updateProject`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// add image in business unit

export const addBusinessUnitImage = async (id, data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}project/imageUpload/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// add doc in busiess unit
export const addBusinessUnitDoc = async (id, data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}project/docUpload/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// get Employ list

export const getEmployList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}project/getEmployList`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
// save employ

export const saveEmploy = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}project/saveEmploys`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
// save project list

export const saveProjectList = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}projects/addListingtoProject`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getDirectory = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}companyDirectory`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getMyBuyers = async (callback, params) => {
  try {
    const response = await axios({
      method: "get",
      params: { sort: params },
      headers,
      url: `${process.env.GATSBY_API_URL}user/myBuyers`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const deleteMyBuyer = async (uid, callback) => {
  try {
    const response = await axios({
      method: "delete",
      headers,
      url: `${process.env.GATSBY_API_URL}user/delete-buyer/${uid}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

// business Detail

export const getBusinessDetail = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}projects/projectDetails`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//directory detail
export const getDirectoryDetail = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}companyDirectory/userDetail`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
//  Dashboard Home
export const getPendingListings = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}user/myListings`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//pending and redeployment
export const getPendingAndRedeployment = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/pending-listing-states`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//active listing
export const getActiveListing = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/active-listing-states`,
    });
    callback(response);
  } catch (e) {
    if (e.response.status === 400) {
      navigate("/");
    }
    callback(e);
  }
};

//Archive lisitng
export const getArchiveListing = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/archive-listing-states`,
    });
    callback(response);
  } catch (e) {
    if (e.response.status === 400) {
      navigate("/");
    }
    callback(e);
  }
};

//Invoiced Lsiting
export const getInvoicedListing = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/invoiced-listing-states`,
    });
    callback(response);
  } catch (e) {
    if (e.response.status === 400) {
      navigate("/");
    }
    callback(e);
  }
};

// lisitng
export const getListings = async (params, callback) => {
  try {
    const response = await axios({
      method: "GET",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}selling/list`,
    });
    callback(response);
  } catch (e) {
    if (e.response.status === 400) {
      navigate("/");
    }
    callback(e);
  }
};

//  Personal Info
export const getPersonalInfo = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/personalInfo`,
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const updatePersonalInfo = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}user/personalInfo`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Languages Preferences
export const updateLanguages = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}user/userLanguage`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getUserLanguages = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/userLanguage`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Change Password
export const changePassword = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}user/changePassword`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Category Preferences
export const updateCategory = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}user/userCategory`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getUserCategory = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      params,
      headers,
      url: `${process.env.GATSBY_API_URL}user/userCategory`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Category Preferences
export const updateRegion = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}user/userRegion`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getUserRegion = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      params,
      headers,
      url: `${process.env.GATSBY_API_URL}user/userRegion`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Manufacturer Preferences
export const updateManufacturers = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}user/userManufacture`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getUserManufacturers = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/userManufacture`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Buying Tab
export const getCurrentBids = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}myLiveBids`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Update Post Listing
export const updatePostListing = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}updateListing`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const updatePostListingBasics = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}updateListingBasics`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const updatePostListingPricing = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}updateListingPrice`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//  WatchList
export const getMyWatchList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/myWatchList`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Product Detail
export const getProductDetail = async (id, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}detail/${id}`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//  Product Detail opensearch refresh
export const getProductDetailRefresh = async (id, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}detail/${id}?hardRefresh=1`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getProductDetailListingRefresh = async (id, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}`, Authorization: `${localStorage.getItem("token")}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}detail/${id}?hardRefresh=1`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//  My Sold Listings
export const getMySoldListings = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/list/sold`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//Listings
export const getAuctionStatusListings = async (value, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/myListings?auctionStatus=${value}`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//Listings
export const getCompanyAuctionStatusListings = async (value, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}selling/company-listing?auctionStatus=${value}`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//link buyer

export const linkBuyer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}linkUser`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const unlinkBuyer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}unlink-user`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const buyerList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}buyer-list`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//add buyer
export const addBuyer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}addUser`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const aiDescp = async (data, callback) => {
  try {
    const response = await axios({
      method: "GET",
      headers: {
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      },
      url: `${process.env.GATSBY_API_URL}ai-detail/${data}`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

//Buyer Inspection apis
export const buyerItemList = async (callback) => {
  try {
    const response = await axios({
      method: "GET",
      headers,
      url: `${process.env.GATSBY_API_URL}buyerInspection/list`,
    });
    return callback(response);
  } catch (e) {
    callback(e);
  }
};

export const uploadSaveDoc = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}buyerInspection/saveDoc`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saveInspectionDate = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}buyerInspection/saveRevisit`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//show logo
export const showPipeLogo = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}auction-company`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

//upload verification doc

export const uploadVerificationDoc = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}register/upload-doc`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const savePaymentInfo = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}user/paymentInfo`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPaymentInfo = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/paymentInfo`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const sendOTP = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}register/sendOtp`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const resendOTP = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}register/re-sendOtp`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const verifyOTP = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}register/verify-otp`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const verifyEmail = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}register/check-email`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const askAviationQuestion = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/aviationPartsEnquiry`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const completeProfile = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}register/complete-profile`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getProfileStatus = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/profile-status`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAuctionToken = async (data, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}create-token/${data}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateEditRequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}update-request`,
      data,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getMyQuestions = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}question/list`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPlaneParts = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/other/planePart`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAviationParts = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      params,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPartManufacturer = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/other/planePartManufacturer`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPlaneCondition = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/other/planeCondition`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPlaneModel = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/other/planeModel`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAviationCount = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/count`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saveProcurementRequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/procurementRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const unsubscribeWeeklyEmail = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}update-send-report-email`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const acceptAllSellerReport = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}accept-all-bid`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const partNumberAuctions = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/auction`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const otherPartsAvialable = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/other`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saveAviationPartLog = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/partNumberAccessLog`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAuctionSpecies = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}report/auction-species`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getSustainabilityReport = async (id, params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}report/carbonOffsetReport/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateDonationstatus = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}report/arr/updateDonationStatus`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const auctionInterest = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}auction-interest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const sendAuctionView = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}auction-view`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAviationPartsCount = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers: {
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      },
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/quantityCount`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getGenericParts = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      params,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getGenericPartsCount = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/quantityCount`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getPartsCondition = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/other/generic/partCondition`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const savePartsProcurementRequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/procurementRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const otherGenericPartsAvialable = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/other`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const genericPartNumberAuctions = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/auction`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saveGenericPartLog = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/partNumberAccessLog`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const genericCountData = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/count`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateNDA = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}nda/signAndSave`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getNDATemplate = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}nda/documentTemplate?type=ncnda&sub_type=body2b`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getProductAnalytic = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}worldMapAndPriceHistory/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
